import React from 'react'
import TasksCard from '../tasksCard'
import RequestsCard from '../requestsCard'
import classes from "./infoRow.module.css"
const InfoRow = () => {
  return (
      <RequestsCard/>        
  )
}

export default InfoRow